/**
 * @module virtual-collection/ui
 * DOM helpers for button states, loading spinners, and error messages.
 */

import { CLASSES } from './constants.js';

/**
 * Sets the submit button to loading state.
 * @param {HTMLElement} button
 * @param {HTMLElement} spinner
 */
export function setLoading(button: HTMLElement, spinner: HTMLElement | null) {
  button.setAttribute('aria-disabled', 'true');
  button.classList.add(CLASSES.loading);
  if (spinner) spinner.classList.remove(CLASSES.hidden);
}

/**
 * Clears the loading state from the submit button.
 * @param {HTMLElement} button
 * @param {HTMLElement} spinner
 */
export function clearLoading(button: HTMLElement, spinner: HTMLElement | null) {
  button.classList.remove(CLASSES.loading);
  button.removeAttribute('aria-disabled');
  if (spinner) spinner.classList.add(CLASSES.hidden);
}

/** Reads a quantity stepper's value; 1 when the input is missing or not a number. */
export function getQuantity(input: HTMLInputElement | null) {
  return input ? parseInt(input.value, 10) || 1 : 1;
}

/**
 * Displays or hides an error message.
 * @param {HTMLElement|null} wrapper - The error wrapper element
 * @param {HTMLElement|null} messageEl - The error message text element
 * @param {string|false} message - Error text, or false to hide
 */
export function handleErrorMessage(
  wrapper: HTMLElement | null,
  messageEl: HTMLElement | null,
  message: string | false = false,
) {
  if (!wrapper) return;
  wrapper.toggleAttribute('hidden', !message);
  if (message && messageEl) {
    messageEl.textContent = message;
  }
}
